import { render, staticRenderFns } from "./ConfigRule.vue?vue&type=template&id=dc4ac806&scoped=true&"
import script from "./ConfigRule.vue?vue&type=script&lang=js&"
export * from "./ConfigRule.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRule.vue?vue&type=style&index=0&id=dc4ac806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ac806",
  null
  
)

export default component.exports